<div style="text-align: right; margin-top: 16px; margin-right: 16px" (click)="onAbbrechen()">
  <mat-icon svgIcon="basics:close"></mat-icon>
</div>

<div mat-dialog-title >Uuups!</div>

<mat-dialog-content>
  <div class="center_column">
    <div style="margin-bottom: 8px">
      <img ngSrc="/assets/technical_error.svg" alt="Technischer Fehler" width="150" height="133" priority/>
    </div>
  </div>
  <div>
    <div class="headline">{{'error.fehler_unterlaufen'|translate}}</div>
    <div>{{'error.arbeiten_an_beseitigung'|translate}}</div>
    <a (click)="onCopyToClipboard()" translate>
      <div class="flex-container">
        <div id="fehlerMeldung" style="display: none">
            <div class="errorText">
              {{ errorMessage.status }}: {{ errorMessage.statustext }}
              <hr />
            </div>
        </div>
        <div>{{'error.fehlerinhalt_kopieren'|translate}}</div>
        <div>
          <mat-icon svgIcon="basics:copy"></mat-icon>
        </div>
      </div>
    </a>
    <br />
  </div>
</mat-dialog-content>
<mat-dialog-actions></mat-dialog-actions>
